import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from '../helpers/withRouter';
import PropTypes from 'prop-types';
import * as Bootstrap from 'react-bootstrap';

import Breadcrumb from '../blocks/Breadcrumb';
import Icons from '../helpers/Icons'
import CustomToggle from '../blocks/CustomToggle'

export class DemonstrativosFormularios extends Component {

    constructor( props ){

        super();
        
        this.state = {
            title: '',
            items: [],
            isLoaded: false
        }

    }

    static propTypes = {
        match: PropTypes.object.isRequired
    };
  
    componentDidMount () {

        const 
            { match } = this.props,
            url = `${process.env.REACT_APP_SERVER_URL}wp-json/bbprev/v1/demonstrativos-e-formularios/${match.params.groupID}?siteID=${window.siteID}`
        ;
        axios
            .get( url )
            .then(( res ) => {
                this.setState({
                    title: res.data.label,
                    items: res.data.items,
                    isLoaded: true
                })
            })
            .catch(
                err => console.log(err)
            )
        ;
  
    }

    render() {

        const 
            { title, items, isLoaded } = this.state,
            toCrumb = {
                path: '/#central-de-informacoes',
                label: 'Central de informações'
            }
        ;

        if( !isLoaded ) return null;

        const 
            firstKey = Object.keys( items ).shift(),
            firstId = items[ firstKey ].id
        ;

        return (
        <div className="page blue demonstrativos-e-formularios">
            <div className="wcf">
                <Breadcrumb data={toCrumb} />
                <h2 className="page-title">{title}</h2>
                <Bootstrap.Accordion defaultActiveKey={firstId}>
                    {Object.keys( items ).map( itemKey => {
                        const item = items[ itemKey ];
                        return ( 
                        <Bootstrap.Card key={item.id}>
                            <Bootstrap.Card.Header>
                                <CustomToggle eventKey={item.id}>{item.label}</CustomToggle>
                            </Bootstrap.Card.Header>
                            <Bootstrap.Accordion.Collapse eventKey={item.id}>
                                <Bootstrap.Card.Body>
                                    {item.items.map(subitem=>
                                        <a href={subitem.url} className="button" key={subitem.id} target="_blank" rel="noreferrer">
                                            {subitem.label}
                                            <Icons tag="download" />
                                        </a>
                                    )}
                                </Bootstrap.Card.Body>
                            </Bootstrap.Accordion.Collapse>
                        </Bootstrap.Card>)
                    })}
                </Bootstrap.Accordion>
            </div>
        </div>);
    
    }

}
  
export default withRouter( DemonstrativosFormularios );